<template>
  <div>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-form class="col s8">
              <v-col cols="12">
                <Subheader
                  icon="mdi-form-textbox-password"
                  title="Benutzerpasswort"
                ></Subheader>
                <div class="mt-7">
                  <v-card>
                    <v-card-text>
                      <div class="subtitle-1">
                        Um die Änderung Deines Benutzerpassworts anzufordern,
                        benötigest Du Zugang zu Deinem E-Mail-Postfach.
                      </div>
                      <v-btn
                        color="primary"
                        depressed
                        text
                        outlined
                        class="mt-3"
                        @click="togglePasswordReset()"
                      >
                        <v-icon left> mdi-lock-reset </v-icon>
                        Passwortänderung anfordern
                      </v-btn>
                      <v-container>
                        <PasswordReset
                          v-if="helpers.passwordResetDialog.model"
                          @close="togglePasswordReset()"
                        ></PasswordReset>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-form>
          </v-row>
          <v-row>
            <v-form class="col s8">
              <v-col cols="12">
                <Subheader
                  icon="mdi-two-factor-authentication"
                  title="Zwei-Faktor-Authentifizierung"
                ></Subheader>
                <div class="mt-7">
                  <v-card>
                    <v-card-text>
                      <div v-if="mfaEnabled">
                        <v-alert
                          type="success"
                          icon="mdi-shield-check"
                          text
                          class="mb-4"
                        >
                          Zwei-Faktor-Authentifizierung ist aktiviert
                        </v-alert>
                        <MFADisable @refresh="checkMFAStatus" />
                      </div>
                      <div v-else>
                        <div class="subtitle-1 mb-4">
                          Erhöhe die Sicherheit Deines Kontos durch die
                          Aktivierung der Zwei-Faktor-Authentifizierung (MFA).
                          Du benötigst zusätzlich zu Deinem Passwort bei der
                          Anmeldung dann einen zeitbasierten Code aus einer
                          Authenticator-App als zweiten Faktor.
                        </div>
                        <MFAEnrollment @refresh="checkMFAStatus" />
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-form>
          </v-row>
          <v-row>
            <v-form class="col s8">
              <v-col cols="12">
                <Subheader
                  icon="mdi-devices"
                  title="Aktive Sitzungen"
                ></Subheader>
                <div class="mt-7">
                  <v-card>
                    <v-card-text>
                      <div class="subtitle-1">
                        Du kannst das Erneuern aktiver Sitzungen auf allen
                        Geräten (einschließlich dieser Sitzung) verhindern und
                        dich so von allen Geräten abmelden. Du musst Dich
                        anschließend auf allen Geräten erneut anmelden.
                      </div>
                      <v-btn
                        color="error"
                        depressed
                        text
                        outlined
                        class="mt-3"
                        @click="toggleRevokeSessionsDialog()"
                      >
                        <v-icon left> mdi-logout </v-icon>
                        Aktive Sitzungen schließen und abmelden
                      </v-btn>
                      <CustomDialog
                        v-if="helpers.revokeSessionsDialog.model"
                        @close="toggleRevokeSessionsDialog()"
                        title="Alle Sitzungen beenden"
                        text="Bist Du sicher? Du wirst auf allen Geräten abgemeldet und musst Dich erneut anmelden."
                        :loading="helpers.revokeSessionsDialog.loading"
                        :btnAction="revokeAllSessions"
                        btnColor="error"
                        btnText="Abmelden"
                        width="s"
                      />
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-form>
          </v-row>
        </v-container>
      </template>
    </section>
    <router-view />
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import PasswordReset from "@/components/Auth/PasswordReset";
import MFAEnrollment from "@/components/Auth/MFAEnrollment.vue";
import MFADisable from "@/components/Auth/MFADisable.vue";
import * as fb from "@/firebase";

export default {
  name: "settings-security",
  components: {
    Subheader,
    CustomDialog,
    PasswordReset,
    MFAEnrollment,
    MFADisable,
  },
  data() {
    return {
      helpers: {
        passwordResetDialog: {
          model: false,
        },
        revokeSessionsDialog: {
          model: false,
          loading: false,
        },
      },
      mfaEnabled: false,
    };
  },
  mounted() {
    this.checkMFAStatus();
  },
  methods: {
    togglePasswordReset() {
      this.helpers.passwordResetDialog.model =
        !this.helpers.passwordResetDialog.model;
    },
    toggleRevokeSessionsDialog() {
      this.helpers.revokeSessionsDialog.model =
        !this.helpers.revokeSessionsDialog.model;
    },
    async revokeAllSessions() {
      this.helpers.revokeSessionsDialog.loading = true;
      try {
        const revokeAllSessionsFn = fb.functions.httpsCallable(
          "auth-revokeAllSessions",
        );
        await revokeAllSessionsFn();
        await this.$store.dispatch("user/SIGN_OUT");
      } catch (error) {
        console.error("Error revoking sessions:", error);
        this.helpers.revokeSessionsDialog.loading = false;
      }
    },
    async checkMFAStatus() {
      try {
        const user = fb.auth.currentUser;
        if (user && user.multiFactor) {
          await user.reload(); // Refresh user data from Firebase
          // Get fresh reference after reload
          const refreshedUser = fb.auth.currentUser;
          this.mfaEnabled =
            refreshedUser.multiFactor.enrolledFactors.length > 0;
        }
      } catch (error) {
        console.error("Error checking MFA status:", error);
      }
    },
  },
};
</script>
